import { Button, TextareaAutosize } from "@mui/material";
import { req } from "./ServerUtils";
import { useState } from "react";

export function SEO() {
    const [subjectsStr, setSubjectsStr] = useState("");

    function add() {
        const subjects = subjectsStr.split("\n").map(s => s.trim()).filter(s => s.length > 0);
        req('/seo/add', 'POST', JSON.stringify({ subjects }));
    }
    function refresh() {
        req('/seo/refresh', 'POST', JSON.stringify({}));
    }
    function updateWordpress() {
        req('/wordpress-jsons/refresh', 'POST', JSON.stringify({}));
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
            alignItems: "start",
            maxWidth: 500,
            margin: "30px auto"

        }}>
            <TextareaAutosize 
                value={subjectsStr}
                onChange={(e) => setSubjectsStr(e.target.value)}
                style={{
                    width: "100%",
                    height: 300,
                    
                    padding: 10,
                    fontSize: 16,
                    border: "1px solid #ccc",
                }} />
            <Button fullWidth onClick={add} variant="outlined" style={{
                textTransform: "none"
            }}>Add Subjects to SEO Page</Button>
            <Button fullWidth onClick={refresh} variant="outlined" style={{
                textTransform: "none"
            }}>Refresh SEO Page</Button>

            <Button fullWidth onClick={updateWordpress} variant="outlined" style={{
                textTransform: "none"
            }}>Refresh Wordpress Plugins</Button>
        </div>
    )
}